import { NotificationItem } from '../notification.interface';

export class ToastNotificatonState {
    public notifications: NotificationItem[] = [];
    public counter: number = 0;
}
